import styled from 'styled-components';
import { deviceHeight } from '../../../designs/devices';

export const Container = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
margin-top:80x;

@media (min-height:300px) { 
    margin-top:10px;
}
  
@media ${deviceHeight.mobileXS} { 
    margin-top:50px;
}

@media ${deviceHeight.mobileM} { 
    margin-top:80px;
`;

export const Img = styled.img`
width: 124.93px;
height: 98.67px;
`;

export const Text = styled.span`
margin-top:42px;
font-family: Nunito;
font-style: normal;
font-weight: 700;
font-size: 20px;
line-height: 28px;
`;

export const Details= styled(Text)`
margin-top:8px;
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 140%;
display:flex;
flex-direction:column;
align-items:center;
`;